module.exports = __webpack_public_path__ + "img/pic_success.793eecfd.svg";